define((require) => {
    "use strict";

    const _                = require("underscore");
    const $                = require("jquery");
    const ImprovedView     = require("editor/zbone/ImprovedView");
    const ParametersHelper = require("shared/ui/experience/action/ParametersHelper");
    const template         = require("ui/experience/action/ParametersPropertiesView.tpl");

    /**
     * Properties view for both ProductLightboxAction and ProductLinkAction.
     *
     * @class ParametersPropertiesView
     * @constructor
     */
    return ImprovedView.extend("ProductActionPropertiesView", {
        template,

        ui: {
            parameterInputs: ".parameter-inputs input"
        },

        events: {
            "blur @ui.parameterInputs": "_handleParameterBlur",
            "focus @ui.parameterInputs": "_handleParameterChange",
            "keyup @ui.parameterInputs": "_handleParameterChange"
        },

        initialize() {
            this._handleParameterChange = _.debounce(this._handleParameterChange, 300);
        },

        /**
         * Sets the actual parameters in the model as the users type them in in the properties
         * view.
         */
        _handleParameterChange(event) {
            const el = event.target;
            const label = el.getAttribute("data-label");
            const parameters = _.clone(this.model.get("parameters"));

            // Sanity check, verifying that the parameter exists in the parameters array.
            if (!parameters.hasOwnProperty(label)) {
                return;
            }

            const oldValue = parameters[label];
            parameters[label] = el.value;
            const hasNewValue = el.value !== oldValue;

            // Even though it probably does not make any sense semantically, we allow for empty parameter values
            // to be inject into urls, probably resulting in bogus urls, for legacy reasons. We should really
            // allow for a proper design of parameters, each specifying validators like "optional" or "mandatory"
            // etc. Then we would not have to guess, but letting the specific client decide... :/
            if (hasNewValue) {
                const newParameters = {};
                this.$el.find(this.ui.parameterInputs).each((index, parameterInput) => {
                    const label = parameterInput.dataset.label;
                    if (label) {
                        newParameters[label] = parameterInput.value;
                    }
                });
                const url = ParametersHelper.inject(this.model.get("urlTemplate"), newParameters); // allow empty parameters!

                this.model.set({
                    parameters: newParameters,
                    url: url
                });
            }
        },

        _hideError(event) {
            const el = event.target;
            const $el = $(el);

            this._displayedError = null;
            $el.popover("hide");
        },

        _handleParameterBlur(e) {
            this._handleParameterChange(e);
            this._hideError(e);
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/product/ProductActionPropertiesView.js